const {
  panelgetResume,
  getFeedbackHistory,
  getPanelDetails,
  getfeedbackforms,
  savefeedbackform,
} = require("../../utils/apiFunctions.js");
const { downloadResumeFile } = require("../../utils/download.js");
const getPanelJdDetails = async (data, objModal) => {
  let payload = {
    jobID: data.jobID,
    interviewRoundID: data.interviewRound.id,
  };

  const res = await getPanelDetails(payload);

  objModal.panelJdDetails = res.data.data.jd;
  if (objModal.panelJdDetails.interviewProcess.process.length >= 5) {
    objModal.panelJdDetails.interviewProcess.process.splice(0, 1);
    objModal.panelJdDetails.interviewProcess.process.splice(-4);
  }
  objModal.jdDetailsType = res.data.data.jdDetailsType;
  // objModal.allDetailDropDowns = "openBasic";
  if (objModal.isLaptop) {
    // objModal.$bvModal.show("viewalljddetails");
    objModal.showAllDetailsJD = true;
  }
};
const getallfeedbackforms = async (data, objModal) => {
  objModal.$v.$reset();
  objModal.showfeedbackSpinner = true;
  objModal.viewfeedback = false;

  objModal.feedback = {
    interviewID: "",
    name: "",
    recommendation: "",
    panelName: "",
    processedBy: "Panel",
    customFeedback: {},
    recOption: "",
  };
  objModal.interviewResponse = data;

  objModal.interviewCandidate = data.candidate.name;
  objModal.panelName = objModal.userInfo.username;

  const dateString = data.startTimeFormatted;

  const dateParts = dateString.split(" ");
  const datePart = dateParts.slice(2).join(" ");
  const dateObject = new Date(datePart);

  if (!isNaN(dateObject.getTime())) {
    const day = dateObject.getDate();
    const month = dateObject.getMonth() + 1;
    const year = dateObject.getFullYear();

    const formattedDate = `${day}-${month}-${year}`;

    objModal.evalDate = formattedDate;
  }
  let feedbackFormID = data.interviewRound.feedbackFormID;
  let finalroundid = data.interviewRound.id;

  let type = 1;
  getfeedbackforms(type, feedbackFormID)
    .then((res) => {
      if (res.status == 200) {
        objModal.showfeedbackSpinner = false;
      }
      const { data } = res.data;
      if (data) {
        if (finalroundid == "F") {
          objModal.feedbackform = { ...data, recOption: "" };
          objModal.$bvModal.show("lastroundfeedback");
        } else {
          objModal.feedbackform = data;
          objModal.$bvModal.show("fillfeedback");

          setTimeout(() => {
            let candimg = document.getElementById("uploadimage");
            let cimg = candimg.clientHeight;
            let candscreenshot = parseInt(cimg) + parseInt(cimg);
            objModal.uploadcandheight = candscreenshot + "px";
            document.querySelector(
              'label[for="uploadcandimage"]'
            ).style.height = candscreenshot + "px";
          }, 100);
        }
      }
    })

    .catch((err) => {
      objModal.showfeedbackSpinner = false;

      throw err;
    });
};

const exportResume = async (data, vueObj) => {
  try {
    let payload = {
      candidateID: data.candidateID,
    };
    if (vueObj && vueObj.interviewDetails) {
      payload["licenseKey"] = vueObj.interviewDetails.licenseKey;
    }
    const res = await panelgetResume(payload);
    if (res.status == 200) {
      const link = res.data.data.resumeLink;
      // implemented bcz once we click on download resume that page shouldn't go blank
      const candidateName = res.data.data.name;

      await downloadResumeFile(link, candidateName);
    }
  } catch (error) {
    console.error(error);
  }
};
const mob_exportResume = async (data, vueObj) => {
  try {
    let payload = {
      candidateID: data.candidate.candidateID,
    };
    if (vueObj && vueObj.interviewDetails) {
      payload["licenseKey"] = vueObj.interviewDetails.licenseKey;
    }
    const res = await panelgetResume(payload);
    if (res.status == 200) {
      const link = res.data.data.resumeLink;
      // implemented bcz once we click on download resume that page shouldn't go blank
      const candidateName = res.data.data.name;

      await downloadResumeFile(link, candidateName);
    }
  } catch (error) {
    console.error(error);
  }
};
const history = async (data, objModal) => {
  try {
    const res = await getFeedbackHistory({
      candidateID: data.candidate.candidateID,
      jobID: data.jobID,
    });
    if (res.status == 200) {
      objModal.feedbackHistory = await res.data.data;
      for (const i of objModal.feedbackHistory) {
        objModal.viewScreenshot = i.candidateImage;
        if (objModal.isLaptop) {
          i.createdAt = objModal.formatTimestamp(i.createdAt);
        }
      }
    }
  } catch (error) {
    console.error(error);
    throw new Error(`Failed! status:${error.status}`);
  }
};

const giveFeedBack = async (objModal) => {
  try {
    if (
      objModal.feedback.recommendation == "DNA" ||
      objModal.feedback.recommendation == "NI"
    ) {
      objModal.$v.recruiterRemarks.$touch();
      if (objModal.$v.recruiterRemarks.$invalid) {
        objModal.errorModal("Please fill all the details");
      } else {
        submitFeedback(objModal);
      }
    } else {
      objModal.$v.$touch();
      if (objModal.$v.$invalid) {
        objModal.errorModal("Please fill all the details");
        if (
          objModal.feedbackform.screenshot &&
          (objModal.feedbackform.screenshotMedia == "" ||
            objModal.feedbackform.screenshotMedia == undefined)
        ) {
          objModal.showErrorImage = true;
        }
      } else if (
        (objModal.feedbackform.screenshot &&
          objModal.feedbackform.screenshotMedia == "") ||
        objModal.feedbackform.screenshotMedia == null
      ) {
        objModal.errorModal("Please upload screenshot");
        objModal.showErrorImage = true;
      } else if (
        !objModal.$v.$invalid ||
        (!objModal.$v.$invalid &&
          objModal.feedbackform.screenshotMedia != "" &&
          objModal.feedbackform.screenshot &&
          !objModal.showErrorImage)
      ) {
        submitFeedback(objModal);
      }
    }
  } catch (err) {
    console.error(err, "err");
    objModal.errorModal("Something went wrong!");
  }
};

const submitFeedback = async (objModal) => {
  objModal.buttonLoader = true;
  let form = new FormData();
  if (
    objModal.feedback.recommendation != "NI" &&
    objModal.feedbackform.recommendation != "DNA" &&
    objModal.feedbackform.screenshot &&
    (objModal.feedbackform.screenshotMedia != "" ||
      objModal.feedbackform.screenshotMedia != undefined)
  ) {
    objModal.feedback.candidateImage = objModal.feedbackform.screenshotMedia;
    form.append("candidateImage", objModal.feedback.candidateImage);
    objModal.feedbackform.screenshotMedia = "";
    this.showErrorImage = false;
  }
  delete objModal.feedbackform.index;
  objModal.feedback.interviewID = objModal.interviewResponse.interviewID;
  form.append("interviewID", objModal.feedback.interviewID);
  form.append("createdBy", objModal.roleValues.userID);
  form.append("createdFor", objModal.roleValues.email);
  if (objModal.showRecOptions) {
    form.append("feedbackLevelID", objModal.feedback.recOption);
    form.append(
      "feedbackTypeID",
      objModal.thirdPartyData.configuration.feedbackTypeID
    );
  }
  objModal.feedback.name = objModal.interviewResponse.candidate.name;
  form.append("name", objModal.feedback.name);
  objModal.feedback.panelName = objModal.interviewResponse.panelist.name;
  form.append("panelName", objModal.roleValues.username);
  objModal.feedback.processedBy = "Panel";
  form.append("processedBy", objModal.feedback.processedBy);
  objModal.feedback.customFeedback = objModal.feedbackform;
  objModal.feedback.customFeedback.basicInfo.name =
    objModal.interviewResponse.candidate.name;
  objModal.feedback.customFeedback.basicInfo.panel =
    objModal.interviewResponse.panelist.name;
  objModal.feedback.customFeedback.basicInfo.experience =
    objModal.interviewResponse.candidate.experience;
  objModal.feedback.customFeedback.basicInfo.modeOfInterview =
    objModal.interviewResponse.interviewRound.type;
  objModal.feedback.customFeedback.basicInfo.evalDate = objModal.currentDate;
  if (
    objModal.feedback.recommendation != "DNA" &&
    objModal.feedback.recommendation != "NI"
  ) {
    form.append(
      "customFeedback",
      JSON.stringify(objModal.feedback.customFeedback)
    );
  }
  form.append("recommendation", objModal.feedback.recommendation);
  form.append("recruiterRemarks", objModal.recruiterRemarks);

  const res = await savefeedbackform(form);
  await giveFeedbackResponse(res, objModal);
};

const giveFeedbackResponse = async (res, objModal) => {
  if (res.status == 200) {
    objModal.buttonLoader = false;
    if (!objModal.isLaptop) {
      objModal.$router.push({
        name: "CandidateDetails",
        query: {
          status: objModal.showGiveFeebackButton,
        },
      });

      // const data = {
      //   candidate: {
      //     candidateID: objModal.interviewResponse.candidate.candidateID,
      //   },
      //   jobID: objModal.interviewResponse.jobID,
      // };

      // await history(data, objModal);
    }
    objModal.$bvModal.hide("fillfeedback");
    objModal.$v.$reset();
    objModal.successModal("Feedback given successfully!");

    objModal.recruiterRemarks = "";
    objModal.$emit("giveLastFdbck");
    objModal.closeFillFeedback();
  } else if (res.status == 409) {
    objModal.$bvModal.hide("fillfeedback");
    objModal.$v.$reset();
    objModal.closeFillFeedback();
    objModal.buttonLoader = false;
    objModal.recruiterRemarks = "";

    objModal.errorModal("Candidate is already selected in other Job");
  } else {
    objModal.buttonLoader = false;
    objModal.errorModal("Something went wrong!");
  }
};
const lastroundgivefeedback = async (objModal) => {
  objModal.$v.$touch();
  objModal.feedback.interviewID = objModal.interviewResponse.interviewID;

  if (objModal.$v.$invalid) {
    objModal.errorModal("Please fill all the details");
  } else if (
    !objModal.$v.recruiterRemarks.$invalid &&
    !objModal.$v.feedback.recommendation.$invalid
  ) {
    let form = new FormData();
    const date = new Date();

    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();

    objModal.getCurrentDate = `${day}/${month}/${year}`;
    objModal.feedback["customFeedback"] = {
      basicInfo: {
        name: objModal.interviewResponse.candidate.name,
        evalDate: objModal.getCurrentDate,
        experience: objModal.interviewResponse.experience,
        panel: objModal.interviewResponse.panelist.name,
      },
    };

    form.append("interviewID", objModal.feedback.interviewID);
    form.append(
      "customFeedback",
      JSON.stringify(objModal.feedback.customFeedback)
    );
    objModal.feedback.name = objModal.interviewResponse.candidate.name;
    form.append("name", objModal.feedback.name);
    form.append("panelName", objModal.panelName);
    objModal.feedback.processedBy = "Panel";
    form.append("processedBy", objModal.feedback.processedBy);
    form.append("recommendation", objModal.feedback.recommendation);
    form.append("recruiterRemarks", objModal.recruiterRemarks);
    if (objModal.showRecOptions) {
      form.append("feedbackLevelID", objModal.feedback.recOption);
      form.append(
        "feedbackTypeID",
        objModal.thirdPartyData.configuration.feedbackTypeID
      );
    } else delete objModal.feedback.recOption;
    savefeedbackform(form)
      .then(async (res) => {
        if (res.status == 200) {
          if (!objModal.isLaptop) {
            objModal.$router.push({
              name: "CandidateDetails",
              query: {
                status: objModal.showGiveFeebackButton,
              },
            });

            const data = {
              candidate: {
                candidateID: objModal.interviewResponse.candidate.candidateID,
              },
              jobID: objModal.interviewResponse.jobID,
            };

            await history(data, objModal);
          }

          objModal.successModal("Feedback given successfully!");
          objModal.recruiterRemarks = "";

          objModal.closeFeedback();
        } else if (res.status == 400) {
          objModal.recruiterRemarks = "";

          objModal.closeFeedback();

          objModal.errorModal("Candidate is already selected in other JD");
        } else {
          objModal.buttonLoader = false;
          objModal.errorModal("Something went wrong!");
        }
        if ([200, 400].includes(res.status)) {
          objModal.$bvModal.hide("lastroundfeedback");
          objModal.closeFeedback();
          objModal.feedback = {
            recommendation: "",
          };
        }
      })
      .catch((err) => {
        objModal.buttonLoader = false;
        objModal.errorModal("Something went wrong!");
        throw err;
      });
  }
};

module.exports = {
  exportResume,
  mob_exportResume,
  history,
  getPanelJdDetails,
  getallfeedbackforms,
  giveFeedBack,
  lastroundgivefeedback,
};
